/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DownloadRequestBuilderRequestsMetadata, type DownloadRequestBuilder } from './download/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /shares/directories/{token}/files/{fileId}
 */
export interface WithFileItemRequestBuilder extends BaseRequestBuilder<WithFileItemRequestBuilder> {
    /**
     * The download property
     */
    get download(): DownloadRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithFileItemRequestBuilderUriTemplate = "{+baseurl}/shares/directories/{token}/files/{fileId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithFileItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithFileItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    download: {
        requestsMetadata: DownloadRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
